export interface Channel {
  id: string;
  name: string;
  description: string;
  image: string;
  genre: string;
  color: string;
}

export interface Track {
  id: string;
  title: string;
  artist: string;
  url: string; // URL to the audio file
  duration: number; // Duration in seconds
  cover: string;
  type: "music" | "jingle" | "voiceover" | "podcast";
}

export interface ScheduleItem {
  track: Track;
  startTime: number; // Unix timestamp in seconds
  endTime: number; // Unix timestamp in seconds
  sourceOffset?: number; // Start playback at this offset (for slicing long files) in seconds
  duration?: number; // OVERRIDE forced duration (essential for podcast segments)
  crossfadeDuration?: number; // Overlap with NEXT track (in seconds)
  overlays?: {
    url: string;
    startAt: number; // Relative to track start
    volume: number;
    type: "intro" | "outro" | "voiceover_overlap" | "music_bed";
    offset?: number; // Start playback at this offset in the overlay file
    duration?: number; // How long to play the overlay
  }[];
}

export const CREATORS_CHOICE_CHANNELS: Channel[] = [
  {
    id: "creators-choice-hiphop",
    name: "Creators Choice: HipHop",
    description:
      "The rawest cuts, the deepest convos. Unfiltered. Unscripted. Pure Heat.",
    image: "/images/hero/hiphop_cover.png",
    genre: "HipHop / Originals",
    color: "#ff4b4b", // Red
  },
  {
    id: "creators-choice-tba-1",
    name: "TBA",
    description: "Coming Soon",
    image: "/images/hero/nano_banana.png",
    genre: "TBA",
    color: "#4b5563", // Gray-600
  },
  {
    id: "creators-choice-tba-2",
    name: "TBA",
    description: "Coming Soon",
    image: "/images/hero/nano_banana.png",
    genre: "TBA",
    color: "#4b5563", // Gray-600
  },
  {
    id: "creators-choice-tba-3",
    name: "TBA",
    description: "Coming Soon",
    image: "/images/hero/nano_banana.png",
    genre: "TBA",
    color: "#4b5563", // Gray-600
  },
];

// --- JINGLES ---
const JINGLE_STANDARD = "/creators_content/jingles/StreameaterDotSE.opus"; // 2.4s
const _JINGLE_WORLDWIDE =
  "/creators_content/jingles/ylstningToStrmetrwrldwide.opus"; // 5.7s
const JINGLE_FEEDBACK = "/creators_content/jingles/Next up feedback.opus"; // 8.3s
const JINGLE_LITCITY =
  "/creators_content/jingles/NextUpLitCityPresentation.opus"; // 2.1s

// --- TRACKS LIBRARY ---
const TRACKS_HIPHOP: Track[] = [
  {
    id: "chrome-to-ya-dome",
    title: "Chrome to ya Dome",
    artist: "Litson",
    url: "/creators_content/music/chrome_to_ya_dome.opus",
    duration: 197.97,
    type: "music",
    cover: "/images/hero/hiphop_cover.png",
  },
  {
    id: "ranger-danger-chill",
    title: "Ranger Danger (Chill)",
    artist: "Litson",
    url: "/creators_content/music/ranger_danger_chill.opus",
    duration: 138.09,
    type: "music",
    cover: "/images/hero/hiphop_cover.png",
  },
  {
    id: "feedback",
    title: "Feedback",
    artist: "Litson",
    url: "/creators_content/music/feedback.opus",
    duration: 164.89,
    type: "music",
    cover: "/images/hero/hiphop_cover.png",
  },
  {
    id: "litcity",
    title: "LitCity",
    artist: "Litson",
    url: "/creators_content/music/LitCity.opus",
    duration: 91.21,
    type: "music",
    cover: "/images/hero/hiphop_cover.png",
  },
  {
    id: "catnip",
    title: "Catnip",
    artist: "Litson",
    url: "/creators_content/music/catnip.opus",
    duration: 163.65,
    type: "music",
    cover: "/images/hero/hiphop_cover.png",
  },
  {
    id: "pinball",
    title: "Lifes like a pinball",
    artist: "Litson",
    url: "/creators_content/music/Lifes%20like%20a%20pinball.opus",
    duration: 131.81,
    type: "music",
    cover: "/images/hero/hiphop_cover.png",
  },
  {
    id: "whats-going-on",
    title: "Whats going on here fella",
    artist: "Litson",
    url: "/creators_content/music/Whats%20going%20on%20here%20fella.opus",
    duration: 212.05,
    type: "music",
    cover: "/images/hero/hiphop_cover.png",
  },
];

const TRACKS_DUB: Track[] = [
  {
    id: "dub-1",
    title: "Root Riddim #1",
    artist: "MephAi",
    url: "/creators_content/music/dub_plate_root_riddim_1.opus",
    duration: 100.97,
    type: "music",
    cover: "/images/hero/dub_cover.png",
  },
  {
    id: "dub-2",
    title: "Root Riddim #2",
    artist: "MephAi",
    url: "/creators_content/music/dub_plate_root_riddim_2.opus",
    duration: 109.85,
    type: "music",
    cover: "/images/hero/dub_cover.png",
  },
  {
    id: "dub-3",
    title: "Root Riddim #3",
    artist: "MephAi",
    url: "/creators_content/music/dub_plate_root_riddim_3.opus",
    duration: 109.41,
    type: "music",
    cover: "/images/hero/dub_cover.png",
  },
  {
    id: "dub-4",
    title: "Root Riddim #4",
    artist: "MephAi",
    url: "/creators_content/music/dub_plate_root_riddim_4.opus",
    duration: 139.81,
    type: "music",
    cover: "/images/hero/dub_cover.png",
  },
];

// PODCAST SOURCES
const POD_HIPHOP: Track = {
  id: "manifesto-pod",
  title: "Raw Energy: The Manifesto",
  artist: "StreamEater Host",
  url: "/creators_content/pod/Raw_Energy_The_Real_Sound_Manifesto.opus",
  duration: 600.5,
  type: "podcast",
  cover: "/images/hero/hiphop_cover.png",
};

const POD_DUB: Track = {
  id: "jamaican-pioneers",
  title: "Stories: Jamaican Pioneers",
  artist: "MephAi History",
  url: "/creators_content/pod/jamaican_pioneers_pod.opus",
  duration: 823.53,
  type: "podcast",
  cover: "/images/hero/dub_cover.png",
};

/**
 * DUB CHANNEL SPECIFIC SCHEDULE
 * Based on transcript timestamps to place songs at natural topic breaks.
 */
const buildDubSpecificSchedule = (
  songs: Track[],
  pod: Track,
  _referenceTime: number,
): ScheduleItem[] => {
  // Transcript Timestamps to Seconds
  // 00:00 - Intro
  // 02:16 - The Dub Plate (Break 1) -> 136s
  // 04:32 - King Tubby (Break 2) -> 272s
  // 06:24 - Lee Scratch Perry (Break 3) -> 384s
  // 08:03 - Augustus Pablo (Break 4) -> 483s
  // 09:20 - Global Influence (Break 5) -> 560s
  // 13:42 - End -> 822s

  const breaks = [136, 272, 384, 483, 560, 822];
  const fullLoop: ScheduleItem[] = [];

  let lastBreak = 0;
  let songIndex = 0;

  breaks.forEach((breakPoint, _i) => {
    const segmentDuration = breakPoint - lastBreak;

    // 1. SELECT SONG FOR THIS TALK SEGMENT
    // This song will have the Talk Overlay (DJ Mode)
    const talkSong = songs[songIndex % songs.length];
    songIndex++;

    // Jingle Logic (Generic)
    let jingleUrl = JINGLE_STANDARD;
    if (talkSong.id === "feedback") jingleUrl = JINGLE_FEEDBACK;
    else if (talkSong.id === "litcity") jingleUrl = JINGLE_LITCITY;

    fullLoop.push({
      track: talkSong,
      startTime: 0,
      endTime: 0,
      duration: talkSong.duration,
      crossfadeDuration: 15,
      overlays: [
        // JINGLE (Standard Intro)
        {
          url: jingleUrl,
          startAt: 0,
          volume: 0.8,
          type: "voiceover_overlap",
          duration: 10, // Short jingle
        },
        // PODCAST "DJ TALK" OVERLAY
        {
          url: pod.url, // The main podcast file
          startAt: 15, // Start talking 15s into the song (let beat drop)
          offset: lastBreak, // Seek to correct segment start
          duration: segmentDuration, // Play just this segment
          volume: 1.0, // Full voice volume
          type: "voiceover_overlap", // This triggers Ducking on the Song
        },
      ],
    });

    // 2. INSERT BUFFER SONGS (Music Only)
    // "Inte allt för ofta" -> 2 empty songs betweeen talks
    for (let k = 0; k < 2; k++) {
      const bufferSong = songs[songIndex % songs.length];
      songIndex++;

      fullLoop.push({
        track: bufferSong,
        startTime: 0,
        endTime: 0,
        duration: bufferSong.duration,
        crossfadeDuration: 15,
        overlays: [
          {
            url: JINGLE_STANDARD,
            startAt: 0,
            volume: 0.6,
            type: "intro", // Different type so it ducks less? Or same.
          },
        ],
      });
    }

    lastBreak = breakPoint;
  });

  return fullLoop;
};

/**
 * GENERIC BUILDER for Pod -> Song -> Pod -> Song flow
 */
const buildInterleavedSchedule = (
  songs: Track[],
  pod: Track,
  referenceTime: number,
  maxSegmentLength?: number,
): ScheduleItem[] => {
  // 1. Define Pod Segments
  let numberOfSegments = songs.length;
  if (maxSegmentLength && maxSegmentLength > 0) {
    numberOfSegments = Math.ceil(pod.duration / maxSegmentLength);
  }
  const segmentDuration = pod.duration / numberOfSegments;

  // 2. Build one full loop of content
  const fullLoop: ScheduleItem[] = [];

  for (let i = 0; i < numberOfSegments; i++) {
    // A. Podcast Segment
    const podStartOffset = i * segmentDuration;

    // Bed Selection Logic (Simplified for generic)
    let bedSong = songs[i % songs.length];
    const bedCandidates = songs.filter(
      (s) => s.id !== songs[i % songs.length].id,
    );
    if (bedCandidates.length > 0) {
      bedSong = bedCandidates[Math.floor(Math.random() * bedCandidates.length)];
    }

    fullLoop.push({
      track: pod,
      startTime: 0,
      endTime: 0,
      sourceOffset: podStartOffset,
      duration: segmentDuration, // Explicit duration
      overlays: [
        {
          url: bedSong.url,
          startAt: 20, // Start 20s into the segment
          volume: 0.2,
          type: "music_bed",
          offset: 0,
          duration: 60,
        },
      ],
    });

    // B. Song (Main Track)
    const song = songs[i % songs.length];

    fullLoop.push({
      track: song,
      startTime: 0,
      endTime: 0,
      duration: song.duration,
      overlays: [
        {
          url: JINGLE_STANDARD,
          startAt: 0,
          volume: 0.8,
          type: "voiceover_overlap",
        },
      ],
    });
  }

  return fullLoop;
};

export const getChannelSchedule = (
  channelId: string,
  referenceTime: number = Date.now() / 1000,
): ScheduleItem[] => {
  // HIP HOP
  if (channelId === "creators-choice-hiphop") {
    // Define specific sequence for HipHop
    const songSequence = [
      TRACKS_HIPHOP[0], // Chrome
      TRACKS_HIPHOP[2], // Feedback
      TRACKS_HIPHOP[1], // Ranger
      TRACKS_HIPHOP[3], // LitCity
      TRACKS_HIPHOP[4], // Catnip
      TRACKS_HIPHOP[5], // Pinball
      TRACKS_HIPHOP[6], // Whats going on
    ];
    return buildInterleavedSchedule(songSequence, POD_HIPHOP, referenceTime);
  }

  // DUB PLATES - Use specific schedule based on transcript timestamps
  if (channelId === "creators-choice-dub") {
    return buildDubSpecificSchedule(TRACKS_DUB, POD_DUB, referenceTime);
  }

  // DEFAULT (Fallback)
  return [];
};
